import greenTick from '@/assets/img/green-tick.png';
import amberTick from '@/assets/img/amber-tick.png';
import redTick from '@/assets/img/red-tick.png';
import truckIcon from '@/assets/img/truck.png';
import carIcon from '@/assets/img/car.png';
import motoIcon from '@/assets/img/moto.png';
import busIcon from '@/assets/img/bus.png';
import containerIcon from '@/assets/img/container.png';
import licensePlateIcon from '@/assets/img/license-plate.png';
import trailerLicensePlateIcon from '@/assets/img/trailer-license-plate.png';
import shipReadingIcon from '@/assets/img/ship-reading.png';
import whitelistIcon from '@/assets/img/whitelist.png';
import brandIcon from '@/assets/img/brand.png';
import adrIcon from '@/assets/img/adr.png';
import wagonIcon from '@/assets/img/wagon.png';
import locomotiveIcon from '@/assets/img/locomotive.png';
import questionMarkIcon from '@/assets/img/question-mark.png';
import checkboxChecked from '@/assets/img/checkbox_checked.png';
import checkboxUnchecked from '@/assets/img/checkbox_unchecked.png';
import radioButton from '@/assets/img/radiobutton.png';
import radioButtonSelected from '@/assets/img/radiobutton_selected.png';
import roadIcon from '@/assets/img/road.png';
import craneIcon from '@/assets/img/crane.png';
import trainIcon from '@/assets/img/train.png';
import shipIcon from '@/assets/img/ship.png';
import filterIcon from '@/assets/img/filter.png';
import locationIcon from '@/assets/img/location.png';
import transitIcon from '@/assets/img/transit.png';
import vehicleClassificationIcon from '@/assets/img/vehicle-classification.png';
import closeButtonIcon from '@/assets/img/close-button.png';
import flagIcon from '@/assets/img/flag.png';
import infoIcon from '@/assets/img/info.png';
import warnIcon from '@/assets/img/warn.png';
import errorIcon from '@/assets/img/error.png';
import alertIcon from '@/assets/img/alert.png';
import csvReportIcon from '@/assets/img/report_csv.png';
import xlsxReportIcon from '@/assets/img/report_xlsx.png';
import loggedInIcon from '@/assets/img/loggedIn.png';
import loadingGif from '@/assets/gif/waiting.gif';
import applicationLogo from '@/assets/img/logo.png';
import camIcon from '@/assets/img/cam.png';
import facilityIcon from '@/assets/img/facility.png';
import adminWarn from '@/assets/img/admin_warn.png';
import passwordResetIcon from '@/assets/img/password-reset.png';
import kebabIcon from '@/assets/img/kebab.png';
import locationPlusIcon from '@/assets/img/location_plus.png';
import deleteIcon from '@/assets/img/delete_bin.png';
import deleteIconDisabled from '@/assets/img/delete_bin_disabled.png';
import crossIcon from '@/assets/img/cross.png';
import containerTareIcon from '@/assets/img/container_tare.png';
import damageDetectionIcon from '@/assets/img/damage_detection.png';
import sealDetectorIcon from '@/assets/img/seal_detector.png';
import forensicImageIcon from '@/assets/img/forensic_image.png';
import forensicImageDisabledIcon from '@/assets/img/forensic_image_disabled.png';
import forensicVideoIcon from '@/assets/img/forensic_video.png';
import forensicVideoDisabledIcon from '@/assets/img/forensic_video_disabled.png';
import mediaDownloadIcon from '@/assets/img/media_download.png';
import mediaDownloadDisabledIcon from '@/assets/img/media_download_disabled.png';
import imageSelectedIcon from '@/assets/img/image_selected.png';
import imageUnselectedIcon from '@/assets/img/image_unselected.png';
import securityPolicyMessageIcon from '@/assets/img/security_message.png';
import securityPolicyIcon from '@/assets/img/security_policy.png';
import userIcon from '@/assets/img/user_icon.png';
import blockedWarnIcon from '@/assets/img/blocked_warn.png';
import lockUserIcon from '@/assets/img/lock_user.png';
import unlockUserIcon from '@/assets/img/unlock_user.png';
import supportIcon from '@/assets/img/support.png';
import republishTransitIcon from '@/assets/img/republish_transit.png';
import intermodalMarkingRailIcon from '@/assets/img/intermodal_marking_rail.png';

import { TRUCK_TYPES, CAR_TYPES, VEHICLE_INFO_TYPES } from './types';

function getVehicleTypeIcon(classificationValue) {
  const noUnderscoreValue = classificationValue.replaceAll('_', ' ');
  if (TRUCK_TYPES.includes(noUnderscoreValue)) return 'truckIcon';
  if (CAR_TYPES.includes(noUnderscoreValue)) return 'carIcon';
  if (noUnderscoreValue === 'motorcycle') return 'motoIcon';
  if (noUnderscoreValue === 'bus') return 'busIcon';
  return 'questionMark';
}

export function getIconName(iconType, classificationValue = null) {
  if (iconType === 'vehicleclassification'
    || iconType === 'vehicledetection') {
    return getVehicleTypeIcon(classificationValue);
  }
  if (VEHICLE_INFO_TYPES.includes(iconType)) return 'brandIcon';
  if (iconType === 'license plate') return 'licensePlateIcon';
  if (iconType === 'trailer license plate') return 'trailerLicensePlateIcon';
  if (iconType === 'shipreading') return 'shipReadingIcon';
  if (iconType === 'whitelist') return 'whitelistIcon';
  if (iconType === 'damagedetection') return 'damageDetectionIcon';
  if (iconType === 'BIC') return 'containerIcon';
  if (iconType === 'adr') return 'adrIcon';
  if (iconType === 'universalwagon') return 'wagonIcon';
  if (iconType === 'road') return 'roadIcon';
  if (iconType === 'train') return 'trainIcon';
  if (iconType === 'crane') return 'craneIcon';
  if (iconType === 'ship') return 'shipIcon';
  if (iconType === 'sealdetector') return 'sealDetectorIcon';
  if (iconType === 'containertare') return 'containerTareIcon';
  if (iconType === 'max_gross_weight') return 'containerTareIcon';
  if (iconType === 'max_net_weight') return 'containerTareIcon';
  if (iconType === 'tare') return 'containerTareIcon';
  if (iconType === 'intermodal_marking_rail') return 'intermodalMarkingRailIcon';
  return 'questionMark';
}

const iconMap = new Map();
iconMap.set('truckIcon', truckIcon);
iconMap.set('carIcon', carIcon);
iconMap.set('motoIcon', motoIcon);
iconMap.set('busIcon', busIcon);
iconMap.set('containerIcon', containerIcon);
iconMap.set('licensePlateIcon', licensePlateIcon);
iconMap.set('trailerLicensePlateIcon', trailerLicensePlateIcon);
iconMap.set('shipReadingIcon', shipReadingIcon);
iconMap.set('whitelistIcon', whitelistIcon);
iconMap.set('brandIcon', brandIcon);
iconMap.set('adrIcon', adrIcon);
iconMap.set('wagonIcon', wagonIcon);
iconMap.set('locomotiveIcon', locomotiveIcon);
iconMap.set('checkboxChecked', checkboxChecked);
iconMap.set('checkboxUnchecked', checkboxUnchecked);
iconMap.set('radioButton', radioButton);
iconMap.set('radioButtonSelected', radioButtonSelected);
iconMap.set('roadIcon', roadIcon);
iconMap.set('craneIcon', craneIcon);
iconMap.set('trainIcon', trainIcon);
iconMap.set('shipIcon', shipIcon);
iconMap.set('filterIcon', filterIcon);
iconMap.set('locationIcon', locationIcon);
iconMap.set('transitIcon', transitIcon);
iconMap.set('vehicleClassificationIcon', vehicleClassificationIcon);
iconMap.set('closeButtonIcon', closeButtonIcon);
iconMap.set('flagIcon', flagIcon);
iconMap.set('infoIcon', infoIcon);
iconMap.set('warnIcon', warnIcon);
iconMap.set('errorIcon', errorIcon);
iconMap.set('greenTick', greenTick);
iconMap.set('amberTick', amberTick);
iconMap.set('redTick', redTick);
iconMap.set('alertIcon', alertIcon);
iconMap.set('csvReportIcon', csvReportIcon);
iconMap.set('xlsxReportIcon', xlsxReportIcon);
iconMap.set('loggedInIcon', loggedInIcon);
iconMap.set('loadingGif', loadingGif);
iconMap.set('applicationLogo', applicationLogo);
iconMap.set('camIcon', camIcon);
iconMap.set('facilityIcon', facilityIcon);
iconMap.set('adminWarn', adminWarn);
iconMap.set('passwordResetIcon', passwordResetIcon);
iconMap.set('locationPlusIcon', locationPlusIcon);
iconMap.set('kebabIcon', kebabIcon);
iconMap.set('deleteIcon', deleteIcon);
iconMap.set('deleteIconDisabled', deleteIconDisabled);
iconMap.set('crossIcon', crossIcon);
iconMap.set('containerTareIcon', containerTareIcon);
iconMap.set('damageDetectionIcon', damageDetectionIcon);
iconMap.set('sealDetectorIcon', sealDetectorIcon);
iconMap.set('forensicImageIcon', forensicImageIcon);
iconMap.set('forensicImageDisabledIcon', forensicImageDisabledIcon);
iconMap.set('forensicVideoIcon', forensicVideoIcon);
iconMap.set('forensicVideoDisabledIcon', forensicVideoDisabledIcon);
iconMap.set('mediaDownloadIcon', mediaDownloadIcon);
iconMap.set('mediaDownloadDisabledIcon', mediaDownloadDisabledIcon);
iconMap.set('imageSelectedIcon', imageSelectedIcon);
iconMap.set('imageUnselectedIcon', imageUnselectedIcon);
iconMap.set('securityPolicyMessageIcon', securityPolicyMessageIcon);
iconMap.set('securityPolicyIcon', securityPolicyIcon);
iconMap.set('userIcon', userIcon);
iconMap.set('blockedWarnIcon', blockedWarnIcon);
iconMap.set('lockUserIcon', lockUserIcon);
iconMap.set('unlockUserIcon', unlockUserIcon);
iconMap.set('supportIcon', supportIcon);
iconMap.set('republishTransitIcon', republishTransitIcon);
iconMap.set('intermodalMarkingRailIcon', intermodalMarkingRailIcon);

export function getIcon(iconName) {
  if (!iconMap.has(iconName)) {
    return questionMarkIcon;
  }
  return iconMap.get(iconName);
}

export function getConfidenceIcon(confidenceValue) {
  const confidence = confidenceValue ?? 0;
  if (confidence >= 0.85) {
    return getIcon('greenTick');
  }
  if (confidence >= 0.6) {
    return getIcon('amberTick');
  }
  return getIcon('redTick');
}
